

define(['angular', 'squid/index', './helper', 'components/xo-models/src/checkout/index', 'components/xo-models/src/auth/index', 'components/xo-models/src/app/index', 'components/xo-models/src/onboard/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.resolvers.country', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app', 'xomodel.onboard']).factory('$CountryResolvers', function ($q, $rootScope, $populate, $util, $meta, $localeHelper, $locale, $AuthModel, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel, $GuestUpgradeModel) {

        return {

            viaCountryPreference: {
                method: function method() {
                    return $locale.chosenCountry;
                }
            },

            viaLocaleTestUrlParam: {
                desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
                method: function method() {
                    var locale = $util.param('locale.test');

                    if (locale) {
                        return $localeHelper.normalizeLocale(locale).country;
                    }
                }
            },

            viaMerchantParam: {
                desc: 'As part of url merchants can pass the locale.x=en_FR or country.x=FR. Here we extract the country param',
                method: function method() {
                    var country = $util.param('country.x');

                    if (country) {
                        return country;
                    }

                    var locale = $util.param('locale.x');

                    return $localeHelper.normalizeLocale(locale).country;
                }
            },

            viaUserProfile: {
                desc: 'From AuthModel. Country comes as "US", "FR" etc. ',
                method: function method() {
                    var data = {};

                    return $populate(data, {
                        auth: $AuthModel.instance()
                    }).then(function () {
                        return data.auth.country;
                    });
                }
            },

            viaCheckoutSession: {
                desc: 'From Merchant locale in CheckoutAppDataModel. merchant_locale comes as en_US etc.',
                method: function method() {
                    // check before creating $CheckoutAppDataModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                    }).then(function () {
                        var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');

                        if (!merchant_locale) {
                            return;
                        }

                        if (merchant_locale.match(/^\w{2}_\w{2}$/)) {
                            return $localeHelper.normalizeLocale(merchant_locale).country;
                        }

                        return merchant_locale;
                    });
                }
            },

            viaCheckoutBilling: {
                desc: 'From Merchant passed billingAddress in CheckoutCart.',
                method: function method() {
                    // check before creating $CheckoutCartModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};
                    return $populate(data, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutCart.get('payer_info.billing_address.country_code');
                    });
                }
            },

            viaCheckoutShipping: {
                method: function method() {
                    // check before creating $CheckoutCartModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutCart.get('purchase.shipping_address.country_code');
                    });
                }
            },

            viaMerchantCountry: {
                method: function method() {
                    // check before creating $CheckoutAppDataModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutAppData.get('merchant.merchant_country');
                    });
                }
            },

            viaGuestAccountCountry: {
                desc: 'From Guest account legal country in ISO country code format (e.g. US, AU)',
                method: function method() {
                    // only perform this resolver for guest-upgrade flow (has data param)
                    if (!$util.param('data')) {
                        return;
                    }

                    return $GuestUpgradeModel.instance().retrieve({
                        error: angular.noop,
                        transientError: true
                    }).then(function (model) {
                        return model.get('user.country');
                    });
                }
            },

            viaCountryCoBrand: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.cobrand');
                    });
                }
            },

            viaLangCookie: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.lang_cookie.country');
                    });
                }
            },

            viaBrowserPref: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.browser_lang.country');
                    });
                }
            },

            viaIP: {
                method: function method() {
                    return $meta.ipcountry;
                }
            },

            viaDefault: {
                method: function method() {
                    return 'US';
                }
            }

        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-locale/dist/country.js
// module id = ./components/xo-locale/dist/country.js
// module chunks = 1